import type { ComponentType } from "react";
import type { UserScheme } from "client-v2";
import step1Image from "../../../assets/images/felicitacion/step-header-1.webp";
import step2Image from "../../../assets/images/felicitacion/step-header-2.webp";
import step3Image from "../../../assets/images/felicitacion/step-header-3.webp";
import step4Image from "../../../assets/images/felicitacion/step-header-4.webp";
import step5Image from "../../../assets/images/felicitacion/step-header-5.webp";
import Step1 from "./Step1";
import Step2 from "./Step2";
import Step3 from "./Step3";
import Step4 from "./Step4";
import Step5 from "./Step5";

export interface FelicitacionStepProps {
	selectedGrandpa?: UserScheme;
}

interface FelicitacionStepDefinition {
	Component: ComponentType<FelicitacionStepProps>;
	imageSrc: string;
	imageAlt: string;
}

export const felicitacionSteps: readonly FelicitacionStepDefinition[] = [
	{
		Component: Step1,
		imageSrc: step1Image,
		imageAlt: "Paso 1",
	},
	{
		Component: Step2,
		imageSrc: step2Image,
		imageAlt: "Paso 2",
	},
	{
		Component: Step3,
		imageSrc: step3Image,
		imageAlt: "Paso 3",
	},
	{
		Component: Step4,
		imageSrc: step4Image,
		imageAlt: "Paso 4",
	},
	{
		Component: Step5,
		imageSrc: step5Image,
		imageAlt: "Paso 5",
	},
] as const;

export const felicitacionTotalSteps = felicitacionSteps.length;
